export enum StoryStepsEnum {
  BASIC_INFO = 'basicInfo',
  CHARACTER_BUILD = 'characterBuild',
  ILLUSTRATION_CREATE = 'illustrationCreate',
  PURCHASE_DOWNLOAD = 'purchaseDownload',
}

export const CONFIG = {
  ADMIN_EMAIL_ADDRESS: process.env.ADMIN_EMAIL_ADDRESS || 'admin@buildmystory.com',
  STORY_STEPS: {
    BASIC_INFO: StoryStepsEnum.BASIC_INFO,
    CHARACTER_BUILD: StoryStepsEnum.CHARACTER_BUILD,
    ILLUSTRATION_CREATE: StoryStepsEnum.ILLUSTRATION_CREATE,
    PURCHASE_DOWNLOAD: StoryStepsEnum.PURCHASE_DOWNLOAD
  },
  TRIAL: {
    START_PAGE_IMAGE_BLOCK: 28,
    MAX_LIMIT_PAGES_TO_CREATE: 28,
  },
  MAX_LIMIT_PAGES_TO_CREATE: 28,
  ONE_STORY_TEXT_PAGES: 11,
  CHARACTER: {
    DUMMY_IMAGE: './dummy.png'
  },
  BILLING: {
    DEDUCT_CREDITS_PER_IMAGE: 1,
    SHIPPING_COST: 6.99,
    ADDITIONAL_PAGE_FEE: 0.95
  },
  FIREBASE_COLLECTIONS: {
    BOOKS: 'booknew'
  },
  BOOK: {
    CHARACTER_REGENERATE_LIMIT: 8,
    PAGE_IMAGE_REGENERATE_LIMIT: 3,
  },
  HEADERS: {
    DEMO_ACCESS_KEY: 'access_key',
    SUBSCRIBE_PLAN_ID: 'subscribe_plan_id',
    CURRENCY: 'currency',
    INVITE_ACCESS_KEY: 'invite_access_token',
    BOOK_SHARE: 'share',
    BOOK_SHARE_QR: 'qr',
  },
  PROMO_PLAN: 'Promo',
  BROWSER_REFRESH_POPUP_PARAM: 'show-refresh-popup',
  ADMIN: {
    DEFAULT_STRESS_TESTING_BOOKS: 5,
  },
  TEACHER: {
    LIMIT_STUDENTS_IN_SCHOOL: 50,
  }
};
